/* Layout */
import Layout from '../../views/layout/Layout.vue'

const OrderList = () => import(/* webpackChunkName: "order-list" */ '@/views/order/list')

export default [
  {
    path: '/order',
    component: Layout,
    redirect: '/order/list',
    name: 'Order',
    alwaysShow: true,
    meta: {
      title: 'order',
      icon: ['fas', 'funnel-dollar'],
    },
    children: [
      {
        path: 'search',
        component: OrderList,
        name: 'OrderList',
        meta: {
          title: 'search',
          icon: 'search',
          accessibleName: 'order',
        },
      },
    ],
  },
]
